import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  LiveSourceStatusFilter,
  LiveSourceProtocolFilter,
} from '../../../domain/live-sources';
import { LIVE_SOURCE_PROTOCOL_OPTIONS } from '../live-sources.constants';

@Component({
  selector: 'evrideo-live-sources-toolbar',
  templateUrl: './live-sources-toolbar.component.html',
  styleUrls: ['./live-sources-toolbar.component.scss'],
})
export class LiveSourcesToolbarComponent implements OnInit, OnDestroy {
  readonly protocolOptions = LIVE_SOURCE_PROTOCOL_OPTIONS;

  @Input() searchQuery: string = '';
  @Input() statusFilter: LiveSourceStatusFilter = 'All';
  @Input() protocolFilter: LiveSourceProtocolFilter = 'All';

  @Output() searchChange = new EventEmitter<string>();
  @Output() statusChange = new EventEmitter<LiveSourceStatusFilter>();
  @Output() protocolChange = new EventEmitter<LiveSourceProtocolFilter>();

  private searchSubject = new Subject<string>();
  private searchSub?: Subscription;

  ngOnInit(): void {
    this.searchSub = this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((query) => this.searchChange.emit(query));
  }

  ngOnDestroy(): void {
    this.searchSub?.unsubscribe();
  }

  onSearchValueChange(value: string): void {
    this.searchSubject.next(value ?? '');
  }

  onStatusValueChange(value: LiveSourceStatusFilter): void {
    this.statusChange.emit(value);
  }

  onProtocolValueChange(value: LiveSourceProtocolFilter): void {
    this.protocolChange.emit(value);
  }

  onClearSearch(): void {
    this.searchSubject.next('');
    this.searchChange.emit('');
  }
}
